import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const TRACK_STYLES = {
  all: {
    accent: 'from-sky-300 via-cyan-200 to-emerald-200',
    badge: 'border-sky-200/60 bg-sky-300/15 text-sky-50',
    button: 'from-white to-sky-100 text-slate-950 hover:from-sky-50 hover:to-white',
    secondary: 'text-white/78 hover:text-white',
  },
  mck: {
    accent: 'from-sky-300 via-blue-200 to-cyan-200',
    badge: 'border-sky-200/60 bg-sky-300/15 text-sky-50',
    button: 'from-white to-sky-100 text-slate-950 hover:from-sky-50 hover:to-white',
    secondary: 'text-sky-50/78 hover:text-white',
  },
  bcg: {
    accent: 'from-emerald-200 via-cyan-100 to-sky-200',
    badge: 'border-emerald-100/70 bg-emerald-300/15 text-emerald-50',
    button: 'from-white to-emerald-100 text-slate-950 hover:from-emerald-50 hover:to-white',
    secondary: 'text-emerald-50/78 hover:text-white',
  },
};

function cx(...values) {
  return values.filter(Boolean).join(' ');
}

export default function LaunchAnnouncementBanner({
  track = 'all',
  badge,
  title,
  body,
  primaryCta,
  secondaryCta,
  onPrimaryCta,
  onSecondaryCta,
  className = '',
}) {
  const styles = TRACK_STYLES[track] || TRACK_STYLES.all;

  return (
    <div
      className={cx(
        'group relative max-w-3xl overflow-hidden rounded-2xl border border-white/18 bg-white/[0.135] p-[1px] shadow-[0_18px_48px_-28px_rgba(2,6,23,0.85)] backdrop-blur-xl',
        className
      )}
    >
      <div className={cx('pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r opacity-90', styles.accent)} />
      <div className="pointer-events-none absolute -right-16 -top-24 h-44 w-44 rounded-full bg-white/15 blur-3xl transition-opacity duration-300 group-hover:opacity-90" />
      <div className="relative flex flex-col gap-4 rounded-2xl bg-[linear-gradient(135deg,rgba(255,255,255,0.17),rgba(255,255,255,0.08))] px-4 py-4 sm:px-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2.5">
            <span className={cx('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em]', styles.badge)}>
              <Sparkles className="h-3.5 w-3.5" strokeWidth={2} />
              {badge}
            </span>
            <span className="text-sm font-extrabold leading-snug text-white sm:text-base">
              {title}
            </span>
          </div>
          <p className="mt-2 max-w-2xl text-sm font-medium leading-relaxed text-white/78">
            {body}
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-3">
          {primaryCta ? (
            <button
              type="button"
              onClick={onPrimaryCta}
              className={cx(
                'inline-flex min-h-10 items-center justify-center gap-2 rounded-xl bg-gradient-to-r px-4 py-2 text-sm font-extrabold shadow-lg shadow-slate-950/15 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0',
                styles.button
              )}
            >
              {primaryCta}
              <ArrowRight className="h-4 w-4" strokeWidth={2.4} />
            </button>
          ) : null}
          {secondaryCta ? (
            <button
              type="button"
              onClick={onSecondaryCta}
              className={cx('text-sm font-bold underline-offset-4 transition hover:underline', styles.secondary)}
            >
              {secondaryCta}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
